import React, { useState } from 'react';
import { Link } from "react-router-dom";

import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import {
} from './userSlice';
import styles from './User.module.css';

export function User() {
  const dispatch = useAppDispatch();
  const [incrementAmount, setIncrementAmount] = useState('4');

  const incrementValue = Number(incrementAmount) || 0;

  return (
    <div>
      <div className={styles.row}>
		  Hello les amis
		  <Link to={"debug"}>debug</Link>
		  <Link to={"/login"}>Login</Link>
      </div>
      <div className={styles.row}>
		  <ul>
			  <li>yo</li>
		  </ul>
      </div>
    </div>
  );
}
